import { useEffect } from 'react';

/** Dev-server fallback — see AppDownloadPage for production static file note. */
export default function InstallPage() {
  useEffect(() => {
    const { search, hash } = window.location;
    window.location.replace(`/install.html${search}${hash}`);
  }, []);

  return (
    <div
      style={{
        background: '#000',
        color: '#f0c060',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Georgia, serif',
      }}
    >
      Loading install instructions…
    </div>
  );
}
